import { render } from "./today.vue?vue&type=template&id=2a5d1616&scoped=true"
import script from "./today.vue?vue&type=script&lang=js"
export * from "./today.vue?vue&type=script&lang=js"

import "./today.vue?vue&type=style&index=0&id=2a5d1616&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5d1616"]])

export default __exports__